import qs from "qs";
import { NavigateFunction } from "react-router";

import { AppNavigatorLink } from "./app-navigator-link";

type AppNavigatorOptions = {
  includeOrigin?: boolean;
};

export class AppNavigator {
  origin = window.location.origin;

  // eslint-disable-next-line no-empty-function
  constructor(private navigateFn: NavigateFunction) {}

  getUrl(url: string, options: AppNavigatorOptions = { includeOrigin: false }) {
    if (options.includeOrigin) return `${this.origin}${url}`;

    return url;
  }

  getNavigateLink(url: string) {
    return new AppNavigatorLink(url, this.navigateFn);
  }

  learn = {
    getLearnUrl: (
      id: string,
      tab?: string,
      opts?: {
        commentId?: string;
        taskId?: string;
      },
    ) => {
      const formattedTab = tab ? `/${tab}` : "";
      const args = opts && qs.stringify(opts);

      return this.getNavigateLink(
        `/learn/${id}${formattedTab}${args ? `?${args}` : ""}`,
      );
    },
  };

  library = {
    getLibraryUrl: (id: string, stepId?: string) => {
      return this.getNavigateLink(`/library/${id}/${stepId ?? ""}`);
    },
  };
}
